import React, { useState, useMemo, useEffect } from 'react';
import { Grid, CircularProgress, Tooltip, IconButton } from '@mui/material';
import { TextInput } from '../../../../../components/textInput/TextInput';
import { CustomDialog } from '../../../../../components/customDialog/CustomDialog';
import credentials from '../../../../../components/common/credential';
import Map from '../../../../../components/common/Map';
import { useDebounce } from '../../../../../hooks/useDebounce';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

export const GeoPosicionProfesional = ({
    handleChange,
    datosDireccion,
    validatedPosition,
    onlyView
}) => {
    const mapURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${credentials.mapsKey}`;

    const [openModal, setOpenModal] = useState(false);
    const [latitud, setLatitud] = useState(datosDireccion?.latitud ?? 0);
    const [longitud, setLongitud] = useState(datosDireccion?.longitud ?? 0);
    const direccionCompleta = useMemo(() => (datosDireccion.direccion + ", " + datosDireccion.localidad + ", " + datosDireccion.provincia), [datosDireccion]);
    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    //resuelve latitud y longitud desde la direccion
    const ubicacion = useMemo(() => (`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(direccionCompleta)}&key=${credentials.mapsKey}`), [direccionCompleta]);
    const debouncedUbicacionValue = useDebounce(ubicacion, 1000);

    useEffect(() => {
        if (!!datosDireccion?.direccion) {
            fetch(ubicacion)
                .then(response => response.json())
                .then(data => {
                    const status = data.status;

                    if (status === "OK") {
                        let location = data.results[0].geometry.location;
                        setLatitud(location.lat);
                        setLongitud(location.lng);
                    } else {
                        console.error('Geocoding failed:', status);
                    }
                })
                .catch(error => console.error('Error al buscar ubicación:', error));
        }
    }, [debouncedUbicacionValue]);

    const handleAccept = () => {
        handleChange('latitud', latitud);
        handleChange('longitud', longitud);
        handleCloseModal();
    }

    return (<>
        <Grid size={{ xs: 20, sm: 10, md: 6, lg: 6 }}>
            <IconButton onClick={handleOpenModal}>
                <LocationOnOutlinedIcon sx={validatedPosition ? { color: '#52BA50' } : {}} />
            </IconButton>
        </Grid>
        <CustomDialog
            maxWidth="md"
            fullWidth={true}
            open={openModal}
            title={'Geo Posicionamiento'}
            onCancel={handleCloseModal}
            onAccept={handleAccept}
            acceptText='Aplicar'
            cancelText='Cerrar'
        >
            <div className='dialog-content'>
                <Grid
                    container
                    justifyContent={'space-between'}
                    columns={{
                        xs: 1,
                        md: 3
                    }}
                    rowGap={1}
                    spacing={2}
                >
                    <Grid size={{ xs: 1, md: 1 }}>
                        <TextInput
                            label='Dirección'
                            placeholder='Dirección'
                            name='direccion'
                            onChange={(e) => { }}
                            disabled={onlyView}
                            value={datosDireccion?.direccion}
                        />
                    </Grid>
                    <Grid size={{ xs: 1, md: 1 }}>
                        <TextInput
                            label='Localidad'
                            placeholder='Localidad'
                            name='localidad'
                            value={datosDireccion?.localidad}
                            onChange={(e) => { }}
                            disabled={onlyView}
                        />
                    </Grid>
                    <Grid size={{ xs: 1, md: 1 }}>
                        <TextInput
                            label='Provincia'
                            placeholder='Provincia'
                            name='provincia'
                            onChange={(e) => { }}
                            disabled={onlyView}
                            value={datosDireccion?.provincia}
                        />
                    </Grid>
                    <Grid size={{ xs: 1, md: 3 }}>
                        <Map
                            key={`${datosDireccion?.direccion + latitud + longitud}`}
                            googleMapURL={mapURL}
                            containerElement={<div style={{ height: '400px' }} />}
                            mapElement={<div style={{ height: '100%' }} />}
                            loadingElement={<CircularProgress disableShrink />}
                            latitud={latitud}
                            longitud={longitud}
                            usuario={null}
                        />
                    </Grid>
                </Grid>
            </div>
        </CustomDialog>
    </>
    );
}